import React from 'react';
import { CSSObject, Icon } from '@chakra-ui/react';
import { CheckCircleOutline } from '@styled-icons/material-rounded/CheckCircleOutline';
import { Stop } from '@styled-icons/octicons/Stop';

export const BetApprovalContainer: CSSObject = {
  px: '0',
  pb: '0',
};

export const EstReturnsLabel: CSSObject = {
  bg: 'white',
  color: 'alpha.800',
  fontWeight: 'extrabold',
  height: '100%',
  alignItems: 'center',
  py: '0,5',
  px: '1',
  width: 'auto',
  borderLeft: '1px solid',
  borderColor: 'blackAlpha.200',
};

export const PendingBetContainer: CSSObject = {
  bg: 'alpha.300',
  borderRadius: 'base',
  w: 'full',
  color: 'black',
  justifyContent: 'center',
  h: '44px',
  boxShadow: 'unset',
};

export const ApprovedBetContainer: CSSObject = {
  background: 'green.400',
  bgGradient: 'none',
  boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.2);',
  borderRadius: 'md',
  w: 'full',
  color: 'black',
  justifyContent: 'center',
};

export const RejectedBetContainer: CSSObject = {
  background: 'red.400',
  bgGradient: 'none',
  boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.2);',
  borderRadius: 'md',
  w: 'full',
  color: 'red.900',
  justifyContent: 'center',
};

export const FooterContainer: CSSObject = {
  bg: 'white',
  color: 'beta.600',
  px: '0',
  h: '22px',
  w: 'auto',
  ml: 'auto',
  py: '1',
  justifyContent: 'end',
  fontSize: '2xs',
  overflow: 'hidden',
  borderRadius: 'base',
  boxShadow:
    '0px 0px 0px 1px rgba(255, 255, 255, 0.10) inset, 0px 2px 5px 0px rgba(0, 0, 0, 0.15)',
};

export const FooterText: CSSObject = {
  fontWeight: 'medium',
  color: 'alpha.800',
};

export const BetApprovalText: CSSObject = {
  fontFamily: 'roboto',
  fontWeight: 'bold',
  fontSize: 'xs',
  color: '#1c4532', // TODO: not in theme
  textShadow: '0 1px 1px rgba(255, 255, 255, 0.35)',
};

export const BetPendingApprovalText: CSSObject = {
  fontFamily: 'Roboto',
  fontWeight: 'bold',
  fontSize: 'md',
  color: 'alpha.800',
};

export const IconApprovedBet = () => (
  <Icon as={CheckCircleOutline} boxSize="5" mr="1" color="green.900" />
);

export const IconRejectedBet = () => (
  <Icon as={Stop} boxSize="4" mr="1.5" color="red.900" />
);

export const BetRejectedText: CSSObject = {
  fontFamily: 'roboto',
  fontWeight: 'bold',
  fontSize: 'xs',
  color: 'red.900',
  textShadow: '0 1px 1px rgba(255, 255, 255, 0.35)',
};
